export default {
  zh: {
    topLovers:"Top Lovers",
    treeOfLovers:"Tree of Lovers",
    rule: 'Rules',
    timeR: 'Count down: ',
    days: 'days',
    ranking:"Ranking",
    rewards:"Rewards",
    rulesDeil:`1.During Ramadan , gifts sent by users on broadcast will be recorded and tallied in this list.<br/><br/>
    2.Gifts sent by users with multiple messages will be combined and counted.<br/><br/>
    3.After the event, the top 10 users will receive rewards.`,
    sesmsg:"The operation was successful",
    rewards:"Rewards",
  },
  ar: {
    topLovers:"اقوى العشاق",
    treeOfLovers:"شجرة الحب",
    rule: 'القواعد',
    timeR: 'العد التنازلي',
    days: 'أيام',
    ranking:"التصنيف",
    rewards:"جوائز",
    rulesDeil:`
    <br/><br/>1.  بخصوص مكافئات صناديق الشحن :<br/>
    - فقط من خلال إعادة شحن الكونز  والمبلغ المحدد يمكن للمستخدم الحصول على المكافأة المقابلة<br/>
    - يمكن تحديد اختيار واحد فقط من المكافئتين .<br/>
    - لا يتم فتح الصندوق عن طريق إعادة شحن الياقوت.<br/>
    2. عندما يتلقى المستخدم مكافآت إعادة الشحن عدة مرات، سيتم تجميع عدد مرات استلام المكافآت .  لن يتم الحصول على المكافآت التي لم يتم الحصول عليها بعد الحدث.<br/>
    3. يتم ترتيب قائمة ترتيب الهدايا من الأعلى إلى الأدنى وفقًا لقيمة الهدايا المحددة المرسلة من قبل المستخدمين.  بعد الحدث، سيحصل أفضل ثلاثة مستخدمين على مكافآت.<br/><br/>
    4. من أجل فتح صناديق العيد، يجب إعادة شحن المبلغ الكامل (لا يتم حساب المبلغ التراكمي)
    `,
    sesmsg:"العملية كانت ناجحه",
    rewards:"جوائز",
    rechargeRewards:"هدايا الشحن",
    rechargeRanking:"جوائز التصنيف",
    rechOne:"شحن $50",
    rechTwo:"شحن $100",
    rechThree:"شحن $200",
    rechargeTips:"تواصل مع خدمة العملاء للشحن",
    getText:"استلام",
    giftText:"هدية",
    modeAit:"عروض الشحن",
    giftranktip:"ارسل الهدايا التالية للانضمام للتصنيف ",
    moAct:"انقر لعرض المزيد من العروض",
    wantTo:"تواصل مع خدمة العملاء للشحن",
    newTtile:"إعادة شحن الكونزات ",
  },
  en: {
    topLovers:"Top Lovers",
    treeOfLovers:"Tree of Lovers",
    rule: 'Rules',
    timeR: 'Count down: ',
    days: 'days',
    ranking:"Ranking",
    rewards:"Rewards",
    rulesDeil:`
    1. About box recharge : <br/>
- Only by recharging coins and the specified amount can the user obtain the corresponding reward<br/>
- Only one of the two rewards can be selected.<br/>
- the box is not opened by recharging rubies.<br/><br/>
2. When a user receives recharge rewards multiple times, the number of times the rewards are received will be accumulated. Rewards that have not been obtained after the event will not be obtained.<br/><br/>
3. The gift ranking list is sorted from high to low according to the value of the specific gifts sent by users. After the event, the top three users will receive rewards.<br/><br/>
4. in order to open Eid boxes, the full amount must be recharged ( the cumulative amount is not calculated ) 
`,
    sesmsg:"The operation was successful",
    rewards:"Rewards",
    rechargeRewards:"Recharge rewards",
    rechargeRanking:"Ranking",
    rechOne:"Recharge$50",
    rechTwo:"Recharge$100",
    rechThree:"Recharge$200",
    rechargeTips:"If you need to recharge, please contact customer service.",
    getText:"Get",
    giftText:"Gift",
    modeAit:"Recharge activities",
    giftranktip:"Join rank by send these gifts:",
    moAct:"Click to view more activities",
    wantTo:"Contact customer service to recharge",
    newTtile:"Gold coin recharge",
  },
  tr: {
    topLovers:"En İyi Aşıklar",
    treeOfLovers:"Sevgi̇ler Ağaci",
    rule: 'Kural',
    timeR: 'Kalan süre: ',
    days: 'gün',
    ranking:"Sıralama",
    rewards:"Çekim Ödülleri",
    rulesDeil:`
    1. Çekim Ödülleri hakkında:<br/>
- Kullanıcı yalnızca Altın ile belirtilen miktarı yeniden çekim yaparak  ilgili ödülü alabilir<br/>
- İki ödülden yalnızca biri seçilebilir.<br/>
- Kutu yakutları yeniden çekim yaparak açılmaz.<br/>
2. Bir kullanıcı Çekim  ödüllerini birden çok kez aldığında, ödüllerin alınma sayısı toplanacaktır. Etkinlik sonrasında kazanılmayan ödüller alınamayacaktır.<br/><br/>
3. Hediye sıralama listesi, kullanıcılar tarafından gönderilen belirli hediyelerin değerine göre yüksekten düşüğe doğru sıralanır. Etkinlik sonrasında ilk üçe giren kullanıcılara belirtilen ödüller verilecektir.<br/><br/>
4. Ramazan Bayramı Etkinliğindeki Çekim kutularını açmak için,Kutuların üzerindeki miktarı Tek seferde çekim yapmalısınız. (kümülatif yani  miktarlar toplanarak hesaplanmaz)`,
    sesmsg:"İşlem Başarılı Oldu",
    rewards:"Ödüller",
    rechargeRewards:"Çekim Ödülleri",
    rechargeRanking:"Çekim Sıralaması",
    rechOne:"Çekim50$",
    rechTwo:"Çekim100$",
    rechThree:"Çekim200$",
    rechargeTips:"Çekim yapmanız  gerekiyorsa lütfen müşteri hizmetlerine başvurun.",
    getText:"Al",
    giftText:"Hediye",
    modeAit:"Çekim Aktiviteleri",
    giftranktip:"Bu hediyeleri göndererek sıralamaya katılın",
    moAct:"Daha fazla aktiviteyi görmek için tıklayın",
    wantTo:"Çekim yapmak için müşteri hizmetleriyle iletişime geçin",
    newTtile:"Altın Çekimi",
  },
  uz:{
    "topLovers": "Eng yaxshi sevuvchilar",
    "treeOfLovers": "Sevuvchilar daraxti",
    "rule": "Qoidalar",
    "timeR": "Sanog'ni boshlash: ",
    "days": "kun",
    "ranking": "Reyting",
    "rewards": "Mukofotlar",
    "rulesDeil": `
    1. Box qayta to'ldirish haqida: <br/>
    - Faqat tangalar va belgilangan miqdor to'ldirilgan holda foydalanuvchi mos mukofotni olish imkoniyatiga ega<br/>
    - Ikki mukofotdan faqat bittasini tanlash mumkin.<br/>
    - Ruby bilan to'ldirish orqali box ochilmaydi.<br/><br/>
    2. Agar foydalanuvchi bir necha bor qayta to'ldirish mukofotlarini olsa, mukofotlar soni to'planadi. Tadbir tugagandan keyin olinmagan mukofotlar berilmaydi.<br/><br/>
    3. Sovg'a reytingi foydalanuvchilar tomonidan yuborilgan maxsus sovg'alar qiymatiga qarab yuqoridan pastga tartiblanadi. Tadbirdan so'ng, eng yuqori uchta foydalanuvchi mukofot oladi.<br/><br/>
    4. Eid box'larini ochish uchun to'liq miqdor to'ldirilishi kerak (yig'ilgan miqdor hisobga olinmaydi)
    `,
    "sesmsg": "Operatsiya muvaffaqiyatli bajarildi",
    "rechargeRewards": "Qayta to'ldirish mukofotlari",
    "rechargeRanking": "Reyting",
    "rechOne": "Qayta to'ldirish $50",
    "rechTwo": "Qayta to'ldirish $100",
    "rechThree": "Qayta to'ldirish $200",
    "rechargeTips": "Agar to'lov qilish kerak bo'lsa, iltimos, mijozlarga xizmat ko'rsatish bilan bog'laning.",
    "getText": "Olish",
    "giftText": "Sovg'a",
    "modeAit": "To'lov faoliyatlari",
    "giftranktip": "Reytingga qo'shish uchun ushbu sovg'alarni yuboring:",
    "moAct": "Boshqa faoliyatlarni ko'rish uchun bosing",
    "wantTo": "Mijozlarga xizmat ko'rsatish bilan to'lov qilishni xohlasangiz",
    "newTtile": "Oltin tangalar bilan to'lov"
},
    ru:{
    "topLovers": "Топ влюбленных",
    "treeOfLovers": "Дерево влюбленных",
    "rule": "Правила",
    "timeR": "Обратный отсчет: ",
    "days": "дни",
    "ranking": "Рейтинг",
    "rewards": "Награды",
    "rulesDeil": `
    1. О пополнении коробки: <br/>
    - Только пополнив монеты и указанный минимальный размер, пользователь может получить соответствующую награду<br/>
    - Можно выбрать только одну из двух наград.<br/>
    - Коробка не открывается при пополнении рубинами.<br/><br/>
    2. Если пользователь получает награды за пополнение несколько раз, количество полученных наград будет суммироваться. Награды, не полученные после события, не будут выданы.<br/><br/>
    3. Список рейтинга подарков сортируется от высокого к низкому по стоимости конкретных подарков, отправленных пользователями. После события трое лучших пользователей получат награды.<br/><br/>
    4. Чтобы открыть коробки Eid, необходимо пополнить полный размер (накопленная сумма не учитывается)
    `,
    "sesmsg": "Операция выполнена успешно",
    "rechargeRewards": "Награды за пополнение",
    "rechargeRanking": "Рейтинг",
    "rechOne": "Пополнить $50",
    "rechTwo": "Пополнить $100",
    "rechThree": "Пополнить $200",
    "rechargeTips": "Если вам нужно пополнить счет, пожалуйста, свяжитесь с службой поддержки.",
    "getText": "Получить",
    "giftText": "Подарок",
    "modeAit": "Активности пополнения",
    "giftranktip": "Присоединитесь к рейтингу, отправив эти подарки:",
    "moAct": "Нажмите, чтобы увидеть другие мероприятия",
    "wantTo": "Свяжитесь с поддержкой для пополнения",
    "newTtile": "Пополнение золотыми монетами"
},
    fa:{
    "topLovers": "برترین عاشقان",
    "treeOfLovers": "درخت عاشقان",
    "rule": "قوانین",
    "timeR": "شمارش معکوس: ",
    "days": "روز",
    "ranking": "رتبه‌بندی",
    "rewards": "جوایز",
    "rulesDeil": `
    1. در مورد شارژ جعبه: <br/>
    - تنها با شارژ سکه‌ها و مقدار مشخص شده، کاربر می‌تواند پاداش مربوطه را دریافت کند<br/>
    - تنها یکی از دو پاداش قابل انتخاب است.<br/>
    - جعبه با شارژ کردن روبی‌ها باز نمی‌شود.<br/><br/>
    2. زمانی که کاربر چندین بار پاداش‌های شارژ را دریافت می‌کند، تعداد دفعات دریافت پاداش‌ها جمع خواهد شد. پاداش‌هایی که پس از رویداد دریافت نشده‌اند، ارائه نمی‌شوند.<br/><br/>
    3. فهرست رتبه‌بندی هدایا بر اساس ارزش هدایای خاصی که کاربران ارسال کرده‌اند، از بالا به پایین مرتب می‌شود. پس از رویداد، سه کاربر برتر جوایز دریافت خواهند کرد.<br/><br/>
    4. برای باز کردن جعبه‌های عید، باید مقدار کامل شارژ شود (مجموع جمع‌آوری‌شده محاسبه نمی‌شود)
    `,
    "sesmsg": "عملیات با موفقیت انجام شد",
    "rechargeRewards": "جوایز شارژ",
    "rechargeRanking": "رتبه‌بندی",
    "rechOne": "شارژ $50",
    "rechTwo": "شارژ $100",
    "rechThree": "شارژ $200",
    "rechargeTips": "اگر نیاز به شارژ دارید، لطفاً با خدمات مشتری تماس بگیرید.",
    "getText": "دریافت",
    "giftText": "هدیه",
    "modeAit": "فعالیت‌های شارژ",
    "giftranktip": "برای پیوستن به رتبه‌بندی این هدایا را ارسال کنید:",
    "moAct": "برای مشاهده فعالیت‌های بیشتر کلیک کنید",
    "wantTo": "برای شارژ با خدمات مشتری تماس بگیرید",
    "newTtile": "شارژ سکه طلایی"
},
    pt:{
    "topLovers": "Top Amantes",
    "treeOfLovers": "Árvore dos Amantes",
    "rule": "Regras",
    "timeR": "Contagem regressiva: ",
    "days": "dias",
    "ranking": "Ranking",
    "rewards": "Recompensas",
    "rulesDeil": `
    1. Sobre o recarregamento da caixa: <br/>
    - Apenas recarregando moedas e a quantidade especificada o usuário pode obter a recompensa correspondente<br/>
    - Somente uma das duas recompensas pode ser selecionada.<br/>
    - A caixa não é aberta ao recarregar rubis.<br/><br/>
    2. Quando um usuário recebe recompensas de recarga várias vezes, o número de vezes que as recompensas foram recebidas será acumulado. Recompensas que não foram obtidas após o evento não serão fornecidas.<br/><br/>
    3. A lista de classificação de presentes é organizada de alto para baixo de acordo com o valor dos presentes específicos enviados pelos usuários. Após o evento, os três primeiros usuários receberão recompensas.<br/><br/>
    4. Para abrir as caixas do Eid, o valor total deve ser recarregado (o valor acumulado não é calculado)
    `,
    "sesmsg": "A operação foi bem-sucedida",
    "rechargeRewards": "Recompensas de recarga",
    "rechargeRanking": "Ranking de recarga",
    "rechOne": "Recarregar $50",
    "rechTwo": "Recarregar $100",
    "rechThree": "Recarregar $200",
    "rechargeTips": "Se precisar recarregar, por favor, entre em contato com o atendimento ao cliente.",
    "getText": "Obter",
    "giftText": "Presente",
    "modeAit": "Atividades de recarga",
    "giftranktip": "Entre no ranking enviando esses presentes:",
    "moAct": "Clique para ver mais atividades",
    "wantTo": "Entre em contato com o atendimento ao cliente para recarregar",
    "newTtile": "Recarregar moedas de ouro"
},
    id:{
    "topLovers": "Pencinta Teratas",
    "treeOfLovers": "Pohon Pencinta",
    "rule": "Aturan",
    "timeR": "Hitung mundur: ",
    "days": "hari",
    "ranking": "Peringkat",
    "rewards": "Hadiah",
    "rulesDeil": `
    1. Tentang pengisian kotak: <br/>
    - Hanya dengan mengisi koin dan jumlah yang ditentukan, pengguna dapat memperoleh hadiah yang sesuai<br/>
    - Hanya satu dari dua hadiah yang dapat dipilih.<br/>
    - Kotak tidak dibuka dengan mengisi rubi.<br/><br/>
    2. Ketika seorang pengguna menerima hadiah pengisian beberapa kali, jumlah kali hadiah diterima akan terakumulasi. Hadiah yang tidak diperoleh setelah acara tidak akan diberikan.<br/><br/>
    3. Daftar peringkat hadiah diurutkan dari tinggi ke rendah berdasarkan nilai hadiah khusus yang dikirim oleh pengguna. Setelah acara, tiga pengguna teratas akan menerima hadiah.<br/><br/>
    4. Untuk membuka kotak Eid, jumlah penuh harus diisi ulang (jumlah kumulatif tidak dihitung)
    `,
    "sesmsg": "Operasi berhasil",
    "rechargeRewards": "Hadiah pengisian",
    "rechargeRanking": "Peringkat pengisian",
    "rechOne": "Isi ulang $50",
    "rechTwo": "Isi ulang $100",
    "rechThree": "Isi ulang $200",
    "rechargeTips": "Jika Anda perlu mengisi ulang, silakan hubungi layanan pelanggan.",
    "getText": "Dapatkan",
    "giftText": "Hadiah",
    "modeAit": "Aktivitas pengisian",
    "giftranktip": "Bergabung dalam peringkat dengan mengirimkan hadiah ini:",
    "moAct": "Klik untuk melihat lebih banyak aktivitas",
    "wantTo": "Hubungi layanan pelanggan untuk mengisi ulang",
    "newTtile": "Isi ulang koin emas"
}





}



// WEBPACK FOOTER //
// src/pages/activity/eid-activities/lang.js